import { NTheme, THEMES, useLocalStorage } from 'nayan';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Categories from './components/categories/Categories';
import Wrapper from './components/helpers/Wrapper';
import { restClient } from './config/Config';
import Images from './components/images/Images';
import Login from './components/auth/Login.tsx';
import ProtectedRoutes from './components/helpers/ProtextedRoutes.tsx';
import PrivacyPolicy from './components/static/PrivacyPolicy.tsx';
import TermsOfUse from './components/static/TermsOfUse.tsx';
import Drawings from './components/drawings/Drawings.tsx';
import DeleteAccount from './components/auth/DeleteAccount.tsx';
import Home from './components/home/Home.tsx';

const App = () => {
  const [theme] = useLocalStorage('THEME', THEMES.LIGHT);

  return (
    <QueryClientProvider client={restClient as any}>
      <NTheme theme={theme}>
        <BrowserRouter>
          <Wrapper>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route element={<ProtectedRoutes />}>
                <Route path="/categories" element={<Categories />} />
                <Route path="categories/:category" element={<Images />} />
                <Route path="/drawings" element={<Drawings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Wrapper>
        </BrowserRouter>
      </NTheme>
    </QueryClientProvider>
  );
};

export default App;
